/* eslint-disable class-methods-use-this */
import http from '@/http';
import Service from './Service';

class InverterService extends Service {
  constructor() {
    super('inverters');
  }

  getInverter() {
    return http.get('/get-inverters');
  }

  getFieldsTableInverters() {
    return [
      {
        key: 'description',
        label: 'Descrição',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'power',
        label: 'Potência',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'overload',
        label: 'Overload (KWP)',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'number_in',
        label: 'N. entradas',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'gauge',
        label: 'Bitola (mm²)',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'mc4',
        label: 'MC-4 (pares)',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'price',
        label: 'Custo ',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
      {
        key: 'actions',
        label: 'Ações',
        tdClass: 'text-center text-nowrap',
        thClass: 'text-center text-nowrap',
      },
    ];
  }
}

const inverterService = new InverterService();
export default inverterService;
